import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAllCampaignsReports } from "../app/api/reports";



export function useCampaignsReport() {
  return useQuery<any>({
    queryKey: ["report"],
    queryFn: fetchAllCampaignsReports,
    staleTime: 1000,
    retry: 1,
  });
}
